// NEW_FILE_JUSTIFIED: Data hook for ReviewPublishPage — aggregates getReviewSnapshot query, listChangeHistory query, and publish mutation into a single typed hook
import { useQuery, useMutation } from 'convex/react'; // CROSS_IMPORT_JUSTIFIED: convex/react is the standard Convex React client package, not a generated file
import { api } from '@convex/_generated/api';
import type { Id } from '@convex/_generated/dataModel';
import type { TReviewSnapshot, TReviewSectionPreview } from '@/@types/insuranceBuilder';

export type { TReviewSnapshot, TReviewSectionPreview };

export function useTypeReviewData(typeId: Id<'orgInsuranceTypes'>) {
  const snapshot = useQuery(api['insurance/types'].getReviewSnapshot, { typeId });
  const history = useQuery(api['insurance/typeHistory'].listChangeHistory, { typeId });
  const publish = useMutation(api['insurance/types'].publish);
  return { snapshot, history, publish };
}
